import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class LoadContainers_ds_get_orders_by_licenseplateService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { licenseplate_id: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Shipment?: { Id?: number, OrderLookups?: { OrderId?: number, Order?: { LookupCode?: string } }[] } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.licenseplate_id)) {
      missingRequiredInParams.push('\'licenseplate_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/LoadContainers/datasources/ds_get_orders_by_licenseplate/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { licenseplate_id: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Shipment?: { Id?: number, OrderLookups?: { OrderId?: number, Order?: { LookupCode?: string } }[] } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.licenseplate_id)) {
      missingRequiredInParams.push('\'licenseplate_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/LoadContainers/datasources/ds_get_orders_by_licenseplate/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { licenseplate_id: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, Shipment?: { Id?: number, OrderLookups?: { OrderId?: number, Order?: { LookupCode?: string } }[] } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.licenseplate_id)) {
      missingRequiredInParams.push('\'licenseplate_id\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/LoadContainers/datasources/ds_get_orders_by_licenseplate/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      licenseplate_id: number[]    }) {
        if(isNil(inParams.licenseplate_id)) {
          return true; 
        }
      return false;
    }
}
